import React, { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

const SubHeader = ({ children }: Props) => {
    return (
        <h2 className="flex pt-3 pb-1 pl-2 text-xs font-bold text-gray-800">
            {children}
        </h2>
    );
};

export default SubHeader;
